import { IcoChecklist16, IcoOrderedList16 } from '@onefootprint/icons';
import type { SlashCommandItem } from '@onefootprint/ui';

const insertInstruction =
  (kind: 'checklist' | 'procedure'): SlashCommandItem['command'] =>
  ({ editor, range }) => {
    const config = JSON.stringify(kind === 'checklist' ? { items: [] } : { steps: [] });
    // Node views read focus at mount; a deferred focus would miss insertion and take it back from the title.
    editor.view.focus();
    editor
      .chain()
      .deleteRange(range)
      .command(({ tr, commands }) => {
        const { $from } = tr.selection;
        // Executable fences must stay outside list items, blockquotes and table cells.
        const position = $from.depth > 1 ? $from.after(1) : tr.selection.from;
        return commands.insertContentAt(position, [
          { type: 'instructionBlock', attrs: { kind, config } },
          { type: 'paragraph' },
        ]);
      })
      .run();
  };

const AGENT_BLOCKS_SECTION = 'Agent instruction blocks';

export const agentBlockSlashCommands: SlashCommandItem[] = [
  {
    title: 'Checklist',
    description: 'Rules the agent must hold to',
    icon: <IcoChecklist16 />,
    section: AGENT_BLOCKS_SECTION,
    command: insertInstruction('checklist'),
  },
  {
    title: 'Procedure',
    description: 'Steps the agent follows in order',
    icon: <IcoOrderedList16 />,
    section: AGENT_BLOCKS_SECTION,
    command: insertInstruction('procedure'),
  },
];
